//imports
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import {
  Grid,
  Box,
  Button,
  Breadcrumbs,
  Link,
  AppBar,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import { useStyles } from "../../assets/styles/Theme";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { externalgetApi } from "../../services/external/externalApis";
import { REPORT_API_01 } from "../../api/ApiModel";
import Navbar from "../../components/common/Navbar";
import CircularProgress from "@mui/material/CircularProgress";
import { CON_MODULECODE } from "../../utils/sys/Constants";

function SelectReports() {
  //hooks
  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();
  const [selectedReports, setSelectedReports] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, GROUPCODE, RESTCODE, USERNAME, MODULECODE } =
    SYS_USER.USER_PARAM || {};

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const result = await externalgetApi(REPORT_API_01, "get", {
        COMPCODE,
        GROUPCODE,
        MODULECODE: CON_MODULECODE,
      });
      setData(result);
      setIsLoading(false);
    } catch (err) {
      setError(err);
      setIsLoading(false);
    }
  };

  // Modified handleRunClick function to accept parameters
  const handleRunClick = (reportId, reportName) => {
    // Navigate to the ReportView with reportId and reportName as state
    navigate("/ReportView", {
      state: { reportId, reportName },
    });
  };

  return (
    <>
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs}
                // position="fixed"
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none">Home</Link>
                <Link underline="none">Select Reports</Link>
              </Breadcrumbs>
            </Grid>
          </Grid>
        </Box>
      </AppBar>

      {/* Main content area */}
      <Box sx={styles.box_container_add}>
        <Grid container spacing={0}>
          <Grid item xs={12}>
            <Box sx={styles.col_title}>
              <Typography
                variant="title"
                align="left"
                sx={{
                  ...theme.typography.h2,
                  color: theme.palette.text.primary,
                  flex: "1 1 100%",
                  ml: 1,
                }}
              >
                Select Reports
              </Typography>
            </Box>
          </Grid>

          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            sx={{
              height: "100%",
              maxHeight: "70vh",
              overflow: "auto",
              "&::-webkit-scrollbar": {
                width: "0.3em",
                height: "0.3em",
              },

              "&::-webkit-scrollbar-thumb": {
                backgroundColor: theme.palette.primary.main,
                borderRadius: "2px",
              },
              "&::-webkit-scrollbar-thumb:hover": {
                backgroundColor: theme.palette.primary.main,
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "start",
                textAlign: "left",
                borderRadius: "4px",
                padding: 0,
              }}
            >
              {/* Mapped Reports with Checkboxes in Two Columns */}
              <Box sx={{ width: "100%", paddingTop: 2 }}>
                <Grid container spacing={2} px={1} py={1}>
                  {/* Check if data is not null and is an array before mapping */}
                  {data && Array.isArray(data) && data.length > 0 ? (
                    data.map((report, index) => (
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        md={4}
                        lg={4}
                        xl={4}
                        key={index}
                      >
                        <Box
                          display="flex"
                          alignItems="center"
                          justifyContent={"space-between"}
                          sx={{
                            backgroundColor: theme.palette.background.paper,
                            borderRadius: "4px",
                            padding: 2,
                            boxShadow: 1,
                          }}
                        >
                          <Typography
                            sx={{
                              color: theme.palette.text.primary,
                              flex: "1 1 100%",
                              ml: 1,
                            }}
                          >
                            {report.REPORTNAME} ({report.REPORTID})
                          </Typography>
                          <Button
                            sx={{
                              background: theme.palette.primary.main,
                              color: theme.palette.text.buttontxt,
                              textTransform: "capitalize",
                              letterSpacing: "1px",
                              width: "80px",
                              transition: "background 0.3s ease", // Optional smooth transition
                              "&:hover": {
                                background: theme.palette.primary.main,
                                color: theme.palette.text.buttontxt, // Change text color on hover
                              },
                            }}
                            onClick={() =>
                              handleRunClick(report.REPORTID, report.REPORTNAME)
                            }
                          >
                            Run
                          </Button>
                        </Box>
                      </Grid>
                    ))
                  ) : (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        minHeight: "60vh",
                      }}
                    >
                      <CircularProgress color="primary" />
                    </Box>
                  )}
                </Grid>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}

export default SelectReports;
